import clsx from "clsx";
import { ButtonHTMLAttributes, FC, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";
import { cva, VariantProps } from "class-variance-authority";

const variants = cva(
  "inline-flex items-center rounded-md border mx-1 border-transparent disabled:bg-gray-300 disabled:cursor-not-allowed  text-sm leading-4 text-white shadow-sm  focus:outline-none",
  {
    variants: {
      variant: {
        primary:
          "bg-secondary-700 focus:ring-secondary-500 hover:bg-secondary-700",
        secondary: "bg-teal-600 focus:ring-teal-500 hover:bg-teal-700",
        warning: "bg-yellow-600 focus:ring-yellow-500 hover:bg-yellow-700",
        tertiary: "bg-gray-600 focus:ring-gray-500 hover:bg-gray-700",
        danger: "bg-red-600 focus:ring-red-500 hover:bg-red-700",
        success: "bg-green-600 focus:ring-green-500 hover:bg-green-700",
      },
      size: {
        sm: "text-xs leading-4 font-medium px-2 py-1",
        md: "text-sm leading-6 font-medium px-3 py-2",
        lg: "text-lg leading-6 font-medium px-4 py-2",
      },
      loading: {
        true: "cursor-wait",
      },
      disabled: {
        true: "opacity-50 cursor-not-allowed",
      },
    },
    compoundVariants: [
      {
        variant: "primary",
        size: "md",
      },
    ],
  }
);

// type Props = {
//   onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
//   disabled?: boolean;
//   loading?: boolean;
//   type?: "button" | "submit" | "reset" | undefined;
// };

type OfficeButtonProps = PropsWithChildren<
  ButtonHTMLAttributes<HTMLButtonElement>
> &
  VariantProps<typeof variants>;

const OfficeButton: FC<OfficeButtonProps> = ({
  children,
  disabled,
  loading,
  size = "md",
  variant = "primary",
  type = "button",
  ...rest
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={clsx(twMerge(variants({ variant, size, loading, disabled })))}
      {...rest}
    >
      {loading ? "Please wait ..." : children}
    </button>
  );
};

export default OfficeButton;
